import React from "react";
import styles from "./Layout.module.css";
import Navbar from "./Navbar";
import Footer from "./Footer";
import FloatingContact from "../components/FloatingButtons/FloatingContact";

export default function Layout({ children }: any) {
  return (
    <div className={styles.layoutWrapper}>
      {/* Navbar */}
      <Navbar />

      {/* Page Content */}
      <main className={styles.contentArea}>
        <div className={styles.innerContent}>{children}</div>
      </main>

      {/* Floating Contact Button */}
      <FloatingContact />

      {/* Footer */}
      <Footer />
    </div>
  );
}
